export const invEstParams = [
    {
        key: '002',
        qty: '1',
        productID: 'IWHDCLAWB-EB',
    },
    {
        key: '012',
        qty: '1',
        productID: 'IWHDCLAWB-EB',
    },
    {
        key: '022',
        qty: '1',
        productID: 'ITCPB-EB',
    },
    {
        key: '100',
        qty: '2',
        productID: 'IWHDCLAWB-EB',
    },
    {
        key: '100',
        qty: '1',
        productID: 'IROLLB10-EB',
    },
    {
        key: '101',
        qty: '4',
        productID: 'IWHDCLAWB-EB',
    },
    {
        key: '101',
        qty: '1',
        productID: 'IROLLB10-EB',
    },
    {
        key: '102',
        qty: '1',
        productID: 'IROLLB10-EB',
    },
    {
        key: '112',
        qty: '1',
        productID: 'IROLLB10-EB',
    },
    {
        key: '122',
        qty: '1',
        productID: 'IROLLB10-EB',
    },
    {
        key: '200',
        qty: '1',
        productID: 'IWHDCLAWB-EB',
    },
    {
        key: '200',
        qty: '1',
        productID: 'IROLLB10-EB',
    },
    {
        key: '201',
        qty: '2',
        productID: 'IWHDCLAWB-EB',
    },
    {
        key: '201',
        qty: '1',
        productID: 'IROLLB10-EB',
    },
    {
        key: '202',
        qty: '1',
        productID: 'IROLLB10-EB',
    },
    {
        key: '212',
        qty: '1',
        productID: 'IROLLB10-EB',
    },
    {
        key: '222',
        qty: '1',
        productID: 'IROLLB10-EB',
    },
    {
        key: '300',
        qty: '2',
        productID: 'IWHDCLAWB-EB',
    },
    {
        key: '300',
        qty: '2',
        productID: 'IROLLB10-EB',
    },
    {
        key: '301',
        qty: '4',
        productID: 'IWHDCLAWB-EB',
    },
    {
        key: '301',
        qty: '2',
        productID: 'IROLLB10-EB',
    },
    {
        key: '302',
        qty: '2',
        productID: 'IROLLB10-EB',
    },
    {
        key: '312',
        qty: '2',
        productID: 'IROLLB10-EB',
    },
    {
        key: '322',
        qty: '2',
        productID: 'IROLLB10-EB',
    },
]
